<div 
    class="input-wrapper"
    [class.error]="inputErrorMessage"
    [class.focus]="focus"
>
    <p 
        class="input-label" 
        [class.show]="(
            inputValue ||
            inputValue == '0'
        ) || focus"
        [class.error]="inputErrorMessage"
        [class.focus]="focus"
        [class.special]="specialPosition"
    >{{ label | translate }}</p>
    <input
        [name]="name"
        [(ngModel)]="inputValue"
        (ngModelChange)="onChange($event)"
        [placeholder]="[focus ? (inputValue | translate) : (label | translate)]"
        [class.error]="inputErrorMessage"
        [class.focus]="focus"
        (focus)="inputFocus()"
        (blur)="inputBlur()"
    />
    <div 
        class="unit"
        *ngIf="unit && (
            inputValue ||
            inputValue == '0'
        )"
    >
        {{ unit | translate }}
    </div>
</div>
<p
    *ngIf="inputErrorMessage"
    class="error-message"
>   
    {{ inputErrorMessage | translate }}
</p>
